export var MapStatus;
(function (MapStatus) {
    MapStatus[MapStatus["LOADING"] = 0] = "LOADING";
    MapStatus[MapStatus["LOADED"] = 1] = "LOADED";
})(MapStatus || (MapStatus = {}));
;



//////////////////
// WEBPACK FOOTER
// C:/Users/Administrator/submit text project/gwin/~/._angular2-baidu-map@3.0.2@angular2-baidu-map/dist/enum/MapStatus.js
// module id = ../../../../._angular2-baidu-map@3.0.2@angular2-baidu-map/dist/enum/MapStatus.js
// module chunks = 5